var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPencilIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62943 0.966337L8.03304 0.369934C7.54024 -0.123311 6.73711 -0.123311 6.24387 0.369934L0.877251 5.73712C0.843444 5.77093 0.818739 5.81254 0.805736 5.85848L0.0108415 8.64155C-0.0173309 8.73994 0.0104081 8.84526 0.082356 8.91765C0.1361 8.97139 0.207615 9 0.281296 9C0.307302 9 0.333307 8.99653 0.358445 8.98916L3.14144 8.19382C3.18739 8.18081 3.22943 8.15611 3.26324 8.1223L8.62943 2.75554C8.86867 2.51672 9 2.19902 9 1.86094C9 1.52286 8.86867 1.20516 8.62943 0.966337ZM2.91643 7.67361L0.689941 8.30946L1.32621 6.08335L5.64786 1.76161L7.23808 3.35187L2.91643 7.67361ZM7.636 2.95444L8.23239 2.35804C8.36502 2.22498 8.43826 2.04857 8.4387 1.86133C8.4387 1.67365 8.36588 1.49681 8.23282 1.36418L7.63643 0.767784C7.36208 0.494289 6.91609 0.493855 6.64216 0.767784L6.04578 1.36418L7.636 2.95444Z",
    fill: "#417FFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilIcon);
export default __webpack_public_path__ + "static/media/edit_pencil_icon.50f71405.svg";
export { ForwardRef as ReactComponent };